import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './file-upload.component';
import { FileUploadModalComponent } from './file-upload-modal/file-upload-modal.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { EllipsisLoadingComponent } from 'src/app/shared/components/ellipsis-loading/ellipsis-loading.component';
import { ConfirmationDialogComponent } from 'src/app/shared/components/modals/confirmation-dialog/confirmation-dialog.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [FileUploadComponent, FileUploadModalComponent],
  imports: [
    CommonModule,
    NgxFileDropModule,
    MatIconModule,
    MatBadgeModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    EllipsisLoadingComponent,
    ConfirmationDialogComponent,
    SharedModule,
  ],
  exports: [
    FileUploadModalComponent,
    FileUploadComponent,
    ConfirmationDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FileUploadModule {
  static forRoot() {
    return {
      ngModule: FileUploadModule,
      schemas: [CUSTOM_ELEMENTS_SCHEMA],
    };
  }
}
